import type {MouseEvent} from 'react';

export const DEFAULT_DIAMETER = 32;
export const PROGRESS_RING_STROKE_WIDTH = 2;
export const PROGRESS_RING_BASE_STROKE_WIDTH = 1;

export interface PlayPauseButtonProps {
  isPlaying: boolean;
  playbackProgress: number;
  onClick(e: MouseEvent): void;
  diameter?: number;
  baseColor?: string;
  iconClassName?: string;
  className?: string;
}
